import { getUnixTime as getUnixTimeFns } from 'date-fns';

export default function getUnixTime(date: Date): number {
  return getUnixTimeFns(date);
}
